module.exports = __webpack_public_path__ + "img/nataliacampos.64e7b3e2.jpg";